// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadHeroCard-cls1_nup","cls2":"DownloadHeroCard-cls2_3E6 DownloadHeroCard-cls1_nup"};